<template>
    <v-card :min-width="Modal.Processamento.larguraMinima" :max-width="Modal.Processamento.larguraMaxima">
        <v-card-title class="primary modal-title" primary-title>
            <span>Retomar Compra</span>
            <v-btn flat depressed @click="fecharModal">
                <v-icon>close</v-icon>
            </v-btn>
        </v-card-title>

        <v-card-text class="az-form-content pa-0">
            <v-layout wrap align-center white class="pa-3">
                <v-flex xs12 sm12 d-flex v-if="!suspensaoPosAnalise">
                    <cd-date-time-picker v-model.lazy="valor.dataHoraInicioEnvioPropostas"
                                       label="Data/Hora Início Envio de Propostas"
                                       name-date="Data Início Envio de Propostas"
                                       name-hour="Hora Início Envio de Propostas"
                                       :min-date="dataMinimaInicicioEnvioProposta"
                                       :nudge-top="50"
                                       :nudge-left="0"/>
                </v-flex>
                
                <v-flex xs12 sm12 d-flex v-if="!suspensaoPosAnalise">
                    <cd-date-time-picker v-model.lazy="valor.dataHoraFimEnvioPropostas"
                                       label="Data/Hora Fim Envio de Propostas"
                                       name-date="Data Fim Envio de Propostas"
                                       name-hour="Hora Fim Envio de Propostas"
                                       :min-date="dataMinimaEncerramento"
                                       :nudge-top="50"
                                       :nudge-left="0"
                                       is-required 
                                       class="required-field"/>
                </v-flex>
                
                <v-flex xs12 sm12 d-flex class="mt-3">
                    <v-textarea 
                        name="Motivo Retomada" 
                        v-model="valor.motivo" 
                        rows="4"
                        placeholder="Informe o motivo" 
                        maxlength="255"
                        :rules="[regras.obrigatorio]"
                        required
                        v-validate="'required'"
                        class="motivo-field"
                        :counter="255">
                        <template v-slot:label>
                            Motivo<span class="asterisco-obrigatorio">*</span>
                        </template>
                    </v-textarea>
                </v-flex>
            </v-layout>
        </v-card-text>

        <v-divider/>

        <v-card-actions class="px-3 py-2">
            <v-btn color="botao-cancelar-color" flat outline @click="fecharModal">
                Cancelar
            </v-btn>
            <v-spacer/>
            <v-btn color="primary"
                   depressed
                   :disabled="!botaoSalvarHabilitado"
                   @click="salvarRetomada">
                Salvar
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { Modal } from '@/core/constants'
import CdDateTimePicker from '@/views/pages/commons/painel/painel-compra-direta/CdDateTimePicker'
import { calcularDiasUteisComHoras } from '@/core/utils/CalcularDiasUteisUtil'

export default {
    name: 'ModalRetomarCompraDireta',
    components: {
        CdDateTimePicker
    },
    props: {
        value: {
            required: true
        },
        suspensaoPosAnalise: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            valor: {
                motivo: '',
                dataHoraInicioEnvioPropostas: '',
                dataHoraFimEnvioPropostas: ''
            },
            Modal,
            regras: {
                obrigatorio: value => !!value || 'Campo obrigatório'
            }
        }
    },
    computed: {
        dataMinimaInicicioEnvioProposta() {
            return this.moment(new Date()).format('YYYY-MM-DD')
        },
        dataMinimaEncerramento() {
            if (this.valor.dataHoraInicioEnvioPropostas) {
                return this.moment(new Date(this.valor.dataHoraInicioEnvioPropostas)).format('YYYY-MM-DD')
            }
            return this.moment(new Date()).format('YYYY-MM-DD')
        },
        botaoSalvarHabilitado() {
            const motivoValido = this.valor.motivo && this.valor.motivo.trim() !== ''
            
            if (this.suspensaoPosAnalise) {
                return motivoValido
            }
            
            return motivoValido && this.valor.dataHoraFimEnvioPropostas
        }
    },
    methods: {
        async salvarRetomada() {
            await this.validarCamposObrigatorios()
            
            if (!this.suspensaoPosAnalise) {
                this.validarDatas()
                this.validarPrazos()
            }
            
            const objParaRetomar = {
                motivo: this.valor.motivo,
                dataHoraInicioEnvioPropostas: this.valor.dataHoraInicioEnvioPropostas
                    ? this.valor.dataHoraInicioEnvioPropostas
                    : this.moment(this.dataAtual()).format('YYYY-MM-DDTHH:mm:ss.SSSZZ'),
                dataHoraFimEnvioPropostas: this.valor.dataHoraFimEnvioPropostas
            }
            this.$emit('salvarRetomada', objParaRetomar)
        },
        fecharModal() {
            this.$emit('fecharModalRetomada')
            this.limparFormulario()
        },
        limparFormulario() {
            this.valor = { 
                motivo: '',
                dataHoraInicioEnvioPropostas: '',
                dataHoraFimEnvioPropostas: ''
            }
        },
        async validarCamposObrigatorios() {
            const erros = []
            
            if (!this.valor.motivo || this.valor.motivo.trim() === '') {
                erros.push('Motivo é obrigatório')
            }
            
            if (!this.suspensaoPosAnalise) {
                if (!this.valor.dataHoraFimEnvioPropostas) {
                    erros.push('Data/Hora Fim Envio de Propostas é obrigatória')
                }
            }
            
            if (erros.length > 0) {
                throw new Error(erros.join('. ') + '.')
            }
        },
        validarPrazos() {
            const amparo = this.$store?.state?.dadosGerais?.amparoLegal
            if (amparo && amparo.prazoMinimoPublicacao && amparo.prazo != null) {
                const inicio = this.valor.dataHoraInicioEnvioPropostas
                    ? this.moment(this.valor.dataHoraInicioEnvioPropostas)
                    : this.moment(this.dataAtual())
                const fim = this.moment(this.valor.dataHoraFimEnvioPropostas)
                const diasUteis = calcularDiasUteisComHoras(inicio, fim)
                if (diasUteis < amparo.prazo) {
                    throw new Error(
                        'O intervalo mínimo entre o início e o término do envio de propostas exigido para este amparo legal deve ser de, no mínimo, ' +
                        amparo.prazo +
                        ' dias úteis.'
                    )
                }
            }
        },
        validarDatas() {
            const dataHoraInicioEnvioPropostas = this.valor.dataHoraInicioEnvioPropostas ? this.moment(this.valor.dataHoraInicioEnvioPropostas) : this.moment(this.dataAtual())
            const dataHoraFimEnvioPropostas = this.moment(this.valor.dataHoraFimEnvioPropostas)
            const dataHoraAtual = this.moment(this.dataAtual())

            if (this.valor.dataHoraInicioEnvioPropostas) {
                if (!dataHoraInicioEnvioPropostas.isAfter(dataHoraAtual)) {
                    throw new Error('A Data/Hora Inicio Envio de Propostas não pode ser anterior a Data/Hora atual.')
                }
            }
            
            if (dataHoraFimEnvioPropostas) {
                if (!dataHoraFimEnvioPropostas.isAfter(dataHoraAtual)) {
                    throw new Error('A Data/Hora Fim Envio de Propostas não pode ser anterior a Data/Hora atual.')
                }
                if (dataHoraInicioEnvioPropostas && !dataHoraFimEnvioPropostas.isAfter(dataHoraInicioEnvioPropostas)) {
                    throw new Error('A Data/Hora Fim Envio de Propostas não pode ser anterior a Data/Hora Inicio Envio de Propostas.')
                }
            }
        },
        dataAtual() {
            return new Date()
        },
        limparFormularioAposSalvar() {
            this.limparFormulario()
        }
    }
}
</script>

<style scoped>
.modal-title {
    justify-content: space-between;
}

.modal-title .v-btn {
    padding: 0;
    margin: 0;
    color: #fff;
    box-sizing: border-box;
    min-width: 25px;
}

.asterisco-obrigatorio {
    color: red;
}
</style>